import Phaser from 'phaser';
import { WEAPONS, PASSIVES } from '../data.js';

export class UpgradeScene extends Phaser.Scene {
  constructor() { super('Upgrade'); }

  init(data) {
    this.gameScene = data.game;
    this.options = data.options;
  }

  create() {
    const W = this.scale.width, H = this.scale.height;
    this.add.rectangle(0, 0, W, H, 0x000010, 0.78).setOrigin(0, 0);
    this.add.text(W / 2, 70, 'LEVEL UP', {
      fontFamily: 'Courier New, monospace', fontSize: '28px', color: '#88ddff',
    }).setOrigin(0.5);
    this.add.text(W / 2, 104, 'choose an upgrade', {
      fontFamily: 'Courier New, monospace', fontSize: '12px', color: '#aab',
    }).setOrigin(0.5);

    const cardW = W - 60;
    const cardH = 100;
    let y = 150;
    this.options.forEach((opt, idx) => {
      this._makeCard(30, y, cardW, cardH, opt, idx);
      y += cardH + 16;
    });

    const rerollsLeft = this.gameScene.player.rerolls;
    const rerollText = `REROLL  (${rerollsLeft} left)`;
    const reroll = this.add.text(W / 2, y + 8, rerollText, {
      fontFamily: 'Courier New, monospace', fontSize: '14px',
      color: rerollsLeft > 0 ? '#ffd755' : '#665',
      backgroundColor: rerollsLeft > 0 ? '#33256a' : '#1a1a28',
      padding: { x: 12, y: 6 },
    }).setOrigin(0.5);
    if (rerollsLeft > 0) {
      reroll.setInteractive({ useHandCursor: true });
      reroll.on('pointerdown', () => {
        this.gameScene.player.rerolls -= 1;
        const newOpts = this.gameScene.rollUpgradeOptions(3);
        this.scene.restart({ game: this.gameScene, options: newOpts });
      });
    }

    this.input.keyboard.on('keydown-ONE',   () => this._choose(0));
    this.input.keyboard.on('keydown-TWO',   () => this._choose(1));
    this.input.keyboard.on('keydown-THREE', () => this._choose(2));
  }

  _makeCard(x, y, w, h, opt, idx) {
    const def = opt.kind === 'weapon' ? WEAPONS[opt.key]
               : opt.kind === 'passive' ? PASSIVES[opt.key]
               : null;
    const color = opt.kind === 'heal' ? 0xff5566 : (def ? def.color : 0xffffff);

    const bg = this.add.rectangle(x + w / 2, y + h / 2, w, h, 0x141430, 0.96)
      .setStrokeStyle(2, color)
      .setInteractive({ useHandCursor: true });

    this.add.rectangle(x + 20, y + h / 2, 30, 30, color)
      .setStrokeStyle(2, 0xffffff, 0.3);

    let title = '', desc = '';
    if (opt.kind === 'weapon') {
      title = def.name + '  L' + opt.nextLevel;
      desc = def.descs[opt.nextLevel - 1] || '';
    } else if (opt.kind === 'passive') {
      title = def.name + '  L' + opt.nextLevel + '/' + def.maxLevel;
      desc = def.desc;
    } else if (opt.kind === 'heal') {
      title = 'Field Repair';
      desc = 'Restore 50% HP.';
    }

    this.add.text(x + 50, y + 18, title, {
      fontFamily: 'Courier New, monospace', fontSize: '16px', color: '#e8e8ff',
    });
    this.add.text(x + 50, y + 44, desc, {
      fontFamily: 'Courier New, monospace', fontSize: '12px', color: '#aab',
      wordWrap: { width: w - 80 },
    });
    this.add.text(x + w - 26, y + 8, String(idx + 1), {
      fontFamily: 'Courier New, monospace', fontSize: '12px', color: '#778',
    });

    bg.on('pointerover', () => bg.setFillStyle(0x251c4a, 1));
    bg.on('pointerout',  () => bg.setFillStyle(0x141430, 0.96));
    bg.on('pointerdown', () => this._choose(idx));
  }

  _choose(i) {
    if (i < 0 || i >= this.options.length) return;
    const choice = this.options[i];
    this.gameScene.applyUpgradeAndContinue(choice);
    this.scene.stop();
  }
}
